import React from 'react';

import Container from '../Container';
import Paper from '../Paper';
import LastReview from '../Reviews/OldReviewsComponents/LastReview';

interface HotelReviewsMobileProps {
  isLastReview: boolean;
  isNewReviewsVariant: boolean;
}

const HotelReviewsMobile = ({
  isLastReview,
  isNewReviewsVariant,
}: HotelReviewsMobileProps) => (
  <>
    {/* trust you и отзывы */}
    {isLastReview && !isNewReviewsVariant && (
      <Container isMobile>
        <Paper padding={10}>{isLastReview && <LastReview isMobile />}</Paper>
      </Container>
    )}
  </>
);

export default React.memo(HotelReviewsMobile);
